export enum GameState {
  MENU = 'MENU',
  LEVEL_INTRO = 'LEVEL_INTRO',
  CHARACTER_WALKING = 'CHARACTER_WALKING',
  ACCIDENT_TRIGGERED = 'ACCIDENT_TRIGGERED',
  CHARACTER_FALLING = 'CHARACTER_FALLING',
  IN_WATER = 'IN_WATER',
  TOOL_SELECTION = 'TOOL_SELECTION',
  AIMING = 'AIMING',
  THROWING = 'THROWING',
  TOOL_IN_FLIGHT = 'TOOL_IN_FLIGHT',
  TOOL_IN_WATER = 'TOOL_IN_WATER',
  RESCUE_INTERACTION = 'RESCUE_INTERACTION',
  SECONDARY_TOOL_SELECTION = 'SECONDARY_TOOL_SELECTION',
  RESCUE_SUCCESS = 'RESCUE_SUCCESS',
  RESCUE_PARTIAL_SUCCESS = 'RESCUE_PARTIAL_SUCCESS',
  RESCUE_FAILURE = 'RESCUE_FAILURE',
  RESULT_SCREEN = 'RESULT_SCREEN',
  PAUSED = 'PAUSED',
}

export enum CharacterState {
  IDLE = 'IDLE',
  WALKING = 'WALKING',
  FALLING = 'FALLING',
  SWIMMING = 'SWIMMING',
  PANICKING = 'PANICKING',
  REACHING = 'REACHING',
  GRABBING_TOOL = 'GRABBING_TOOL',
  WEARING_VEST = 'WEARING_VEST',
  TANGLED = 'TANGLED',
  DAZED = 'DAZED',
  BEING_TOWED = 'BEING_TOWED',
  SAFE = 'SAFE',
  LOST_DOWNSTREAM = 'LOST_DOWNSTREAM',
}

export enum ToolState {
  AVAILABLE = 'AVAILABLE',
  SELECTED = 'SELECTED',
  AIMING = 'AIMING',
  THROWN = 'THROWN',
  FLOATING = 'FLOATING',
  ATTACHED = 'ATTACHED',
  DAMAGED = 'DAMAGED',
  LOST = 'LOST',
  USED = 'USED',
}
